/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from "react";
import axios from "axios";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalBody,
} from "@chakra-ui/modal";
import Card from "components/card";
import { Button } from '@chakra-ui/react';
import { TokenManager } from "utils/tokenManager";

const AgentRevokeSubaccountConfirmModal: React.FC<{
    agentDetail: any;
    subaccountDetailToRevoke: any;
    isOpen: boolean;
    onClose(): void;
    triggerReloadList(): void;
    setSwalProps: any;
}> = ({ isOpen, onClose, triggerReloadList, agentDetail, subaccountDetailToRevoke, setSwalProps }) => {

    const [isProcessing, setIsProcessing] = useState<boolean>(false);
    const userRole = localStorage.getItem("userRole");

    const closeModal = async () => {
        onClose();
    };

    const handleSubmit = async () => {
        try {
            const data = {
                username: localStorage.getItem("username"),
                userRole: userRole,
                action: "remove",
                agnt_id: agentDetail.id,
                suba_id: subaccountDetailToRevoke.id,
                agentName: agentDetail.suba_name,
                subaccountName: subaccountDetailToRevoke.suba_name
            }

            setIsProcessing(true);
            await axios.post(process.env.REACT_APP_API_URL + `/api/${localStorage.getItem("userRole")?.toLowerCase()}/agent/action/agent-subaccount-manage`, data)
                .then(function (response) {
                    triggerReloadList();
                    if (response && response.data?.status === 'ok') {
                        closeModal();
                        setSwalProps({
                            show: true,
                            icon: "success",
                            title: "Success",
                            html: "Subaccount has been revoked",
                            showConfirmButton: true,
                            didClose: () => {
                                setSwalProps({});
                                setIsProcessing(false);
                            },
                        });
                    } else {
                        setIsProcessing(false);
                    }
                })
                .catch(function (error) {
                    setIsProcessing(false);
                    setSwalProps({
                        show: true,
                        icon: "error",
                        title: "Oops!",
                        html: error.response.data.message,
                        showConfirmButton: true,
                        didClose: () => {
                            setSwalProps({});
                            setIsProcessing(false);
                        },
                    });
                });
        } catch (error: any) {
            setIsProcessing(false);
            setSwalProps({
                show: true,
                icon: "error",
                title: "Oops!",
                html: "Something went wrong, please try again later.",
                showConfirmButton: true,
                didClose: () => {
                    setSwalProps({});
                    setIsProcessing(false);
                },
            });
        }
    };

    return (
        <>
            {agentDetail &&
                <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
                    <ModalOverlay className="bg-[#000] !opacity-30" />
                    <ModalContent className="dark:!bg-neutral-900 !z-[1002] !m-auto !w-full max-w-xl !rounded-2xl !border !border-gray-200 !bg-white !shadow-xl dark:!border-white/10 md:!top-[12vh]">
                        <ModalBody className="p-6 md:p-7">
                            <div className="mb-4 flex items-start gap-3">
                                <div className="rounded-xl bg-red-50 p-2 text-red-600 ring-1 ring-red-100 dark:bg-red-900/20 dark:text-red-400 dark:ring-red-900/30">
                                    <svg
                                        viewBox="0 0 24 24"
                                        className="h-5 w-5"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                    >
                                        <path d="M12 9v4m0 4h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z" />
                                    </svg>
                                </div>
                                <div>
                                    <h1 className="text-lg font-semibold text-gray-900 dark:text-white">
                                        Revoke Subaccount — Confirmation
                                    </h1>
                                    <p className="mt-1 text-sm text-gray-600 dark:text-gray-300">
                                        This action cannot be undone. Please review the details carefully.
                                    </p>
                                </div>
                            </div>

                            <div className="mb-4 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-800 dark:border-red-900/40 dark:bg-red-900/20 dark:text-red-300">
                                You are about to revoke this subaccount from agent. This action is{" "}
                                <span className="font-medium">permanent</span>.
                            </div>

                            <div className="dark:bg-neutral-800/50 mb-6 rounded-xl bg-gray-50 p-4 ring-1 ring-gray-100 dark:ring-white/10">
                                <dl className="flex flex-col gap-3 text-sm">
                                    <div className="flex">
                                        <dt className="w-24 shrink-0 text-gray-700 dark:text-gray-400">
                                            ID
                                        </dt>
                                        <dd className="font-medium text-gray-900 dark:text-white">
                                            {subaccountDetailToRevoke.id}
                                        </dd>
                                    </div>

                                    <div className="flex">
                                        <dt className="w-24 shrink-0 text-gray-700 dark:text-gray-400">
                                            Name
                                        </dt>
                                        <dd className="font-medium text-gray-900 dark:text-white">
                                            {subaccountDetailToRevoke.suba_name}
                                        </dd>
                                    </div>
                                </dl>
                            </div>

                            <div className="flex justify-end gap-2">
                                <Button
                                    onClick={() => closeModal()}
                                    isDisabled={isProcessing}
                                    className="btn btn-default"
                                >
                                    Not now
                                </Button>

                                <Button
                                    onClick={() => handleSubmit()}
                                    disabled={isProcessing || TokenManager.isImpersonating()}
                                    isLoading={isProcessing}
                                    loadingText='Processing...'
                                    className="btn text-white bg-red-600 hover:bg-red-500">
                                    Revoke
                                </Button>
                            </div>
                        </ModalBody>
                    </ModalContent>
                </Modal>
            }
        </>
    );
};

export default AgentRevokeSubaccountConfirmModal;